import React from "react";
import { motion } from "framer-motion";

const Loader = () => {
  return (
    <div className="loader-container bg-black flex flex-col items-center justify-center min-h-screen">
      {/* Spinner */}
      <motion.div
        className="loader-spinner w-16 h-16 rounded-full border-4 border-t-blue-400 border-r-red-400 border-b-white border-l-orange-400"
        animate={{ rotate: 360 }}
        transition={{
          repeat: Infinity,
          duration: 1.2,
          ease: "linear",
        }}
      />

      {/* Loading Text */}
      <motion.p
        className="loader-text text-gray-300 mt-4 text-lg font-medium"
        initial={{ opacity: 0 }}
        animate={{ opacity: [0, 1, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
      >
        Loading...
      </motion.p>
    </div>
  );
};

export default Loader;
